var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "消息通知设置",
        width: "400px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "msgSetting" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "通知开启", prop: "enable" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: !_vm.ifEdit },
                      model: {
                        value: _vm.form.enable,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "enable", $$v)
                        },
                        expression: "form.enable",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("开启"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("关闭"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.enable
                ? _c(
                    "el-form-item",
                    { attrs: { label: "消息指令", prop: "cmd" } },
                    [
                      !_vm.ifEdit
                        ? [
                            _vm._v(" " + _vm._s(_vm.form.cmd) + ": "),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "点击复制",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "m-l-10",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyText()
                                      },
                                    },
                                  },
                                  [_vm._v("复制")]
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "el-input",
                              {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  placeholder: "请输入",
                                  maxlength: "5",
                                },
                                model: {
                                  value: _vm.form.cmd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "cmd", $$v)
                                  },
                                  expression: "form.cmd",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v(":"),
                                ]),
                              ],
                              2
                            ),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  !_vm.ifEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { loading: _vm.loading, type: "primary" },
                          on: { click: _vm.onhandleEdit },
                        },
                        [_vm._v("编辑")]
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: { loading: _vm.loading, type: "primary" },
                          on: { click: _vm.onhandleSave },
                        },
                        [_vm._v("保存")]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }